import fs from 'node:fs'
import path from 'node:path'
import { CONFIG_FILE_NAME } from '@cli-constants/paths.js'
import { loadConfigFile } from '@core-engine/config/resolver/load-config-file.js'
import { normalizeNamespaceForRemoval } from './normalize-namespace-for-removal.js'
import { readNamespaceFromConfigSource } from './read-namespace-from-config-source.js'

export async function readExistingConfigNamespace(cwd: string): Promise<string | undefined> {
  const configPath = path.resolve(cwd, CONFIG_FILE_NAME)
  if (!fs.existsSync(configPath)) {
    return
  }

  const sourceNamespace = readNamespaceFromConfigSource(fs.readFileSync(configPath, 'utf-8'))
  if (sourceNamespace) {
    return sourceNamespace
  }

  try {
    const loadedConfig = await loadConfigFile(configPath)
    return normalizeNamespaceForRemoval(loadedConfig.frameworkConfig?.next?.namespace)
  } catch {
    return
  }
}
